import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'erp',   //theme name
        true,       //loadingSpinner
        true,      //fixedHeader
        true,      //fixedSidenav
        false,      //fixedSidenavUserContent
        false,      //fixedFooter
        true,       //sidenavIsOpened
        true,       //sidenavIsPinned  
        'vertical', //horizontal , vertical
        'default',  //default, compact, mini
        'indigo-light',   //indigo-light, teal-light, red-light, gray-light, blue-dark, green-dark, pink-dark, gray-dark
        false       // true = rtl, false = ltr
    )

    public numberPattern = '^[0-9]\\d*(\\.\\d{1,2})?$';
    public mobilePattern = '^(?:\\+91|91)?[6-9][0-9]{9}$';
    public gstinPattern = '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$';
    public pancard = '^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$';
    public onlyNumber = '^[0-9]+$';
    public namePattern = '^[a-zA-Z.\\s]*';
    public namePatternWithoutSpace = '^[a-zA-Zs]*';
    public ifscPattern = '^[A-Z]{4}0[A-Z0-9]{6}$';
    public hsnPattern = '^[0-9]{6}$';
   // public aplhaNumeric = '^[A-Za-z0-9 ]+$';
    public aplhaNumeric = "^[a-zA-Z0-9&,.\\- ]*$";
    public mobileNumber = '^((\\+91-?)|0)?[0-9]{10}$';
    public pincode = '^[1-9][0-9]{5}$';
    public onlyNumberWithDot = '^\\d+(\\.\\d+)?$';
   // public alphabateandNumber = '^(?=.*[A-Za-z])[A-Za-z0-9 ]+$';
     public alphabateandNumber = '^[A-Za-z0-9&,.\\- ]+$';
    public pricePattern = '^\\d+(\\.\\d{1,4})?$';

    termsAndConditionList = [
        {
            name: 'PO',
        },
        {
            name: 'PAYEMENT',
        },
        {
            name: 'DELIVERY_BASIS',
        },
        {
            name: 'OTHER_CHARGES',
        },
        {
            name: 'OTHER',
        }
    ]

    PO_types =[
        {
            id:1,
            name: 'PO(To Site)',
        },
        {
            id:2,
            name: 'Office PO',
          //  name: 'To Godown',
        },
        {
            id:3,
            name: 'PO(Supplier to Godown to Site)',
        },
        {
            id:4,
          //  name: 'Godown to Site',
          name: 'Issue Slip',
        }
    ]
    
    document_types =[
        {
            id:1,
            name: 'PO',
        },
        {
            id:2,
            name: 'GRN',
        },
        
    ]

    gstTypes=['INCLUDING','EXCLUDING'];

    supply = [ 'Supply','Installation','Both']

    poGSTType = ['Without GST','INCLUDING','EXCLUDING'];

    projectType = ['Government','Private','Industrial','Other']

    siteDeposite = ['SD','EMD','FDR','Tender Cost','other']

    WOStatus = ['RUNNING','HOLD','FINISHED']

    PaymentMode = ['BY CHEQUE','By DD','BY NEFT','BY RTGS','BY PETTY CASH']

}

